import { XCircleIcon } from '@heroicons/react/20/solid';
import React from 'react';

interface ClearButtonProps {
  isVisible: boolean;
  labelPrefix: string;
  onClear: () => void;
}

export const ClearButton: React.FC<ClearButtonProps> = ({ isVisible, labelPrefix, onClear }) => {
  if (!isVisible) return null;

  return (
    <button
      aria-label={`Clear ${labelPrefix.toLowerCase().replace(':', '')} filter`}
      className="focus:border-fiona relative -ml-px inline-flex shrink-0 items-center gap-x-1.5 rounded-r-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50 focus:relative focus:z-10 focus:shadow-[0_0_0_2px_theme(colors.fiona)] focus:outline-none"
      onClick={onClear}
      type="button"
    >
      <XCircleIcon aria-hidden="true" className="-ml-0.5 h-5 w-5 text-gray-400" />
      Clear
    </button>
  );
};
